<template>
    <app-layout title="Buchung">
        <Section>
            <Container>
                <div>
                    <div>
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Buchung
                        </h3>
                        <p class="mt-1 max-w-2xl text-gray-500">
                            Hier finden Sie alle Informationen zur Buchung.
                        </p>
                    </div>
                    <div class="mt-5 border-t border-gray-200">
                        <dl class="sm:divide-y sm:divide-gray-200">
                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Abholdatum
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.start_date }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Rückgabedatum
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.end_date }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Inklusiv km
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.km }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Zusatz km
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.additional_km }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Zahlungsstatus
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.payment_status }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Gesamtbetrag
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.total_price }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Kaution
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.bail }}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>

                <div class="mt-10">
                    <div>
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Fahrzeug
                        </h3>
                        <p class="mt-1 max-w-2xl text-gray-500">
                            Hier finden Sie alle Informationen zum Fahrzeug.
                        </p>
                    </div>
                    <div class="mt-5 border-t border-gray-200">
                        <dl class="sm:divide-y sm:divide-gray-200">
                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Fahrzeugtyp
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.vehicle_type }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Fahrzeug
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.vehicle }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Kennzeichen
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.vehicle_plate }}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>

                <div class="mt-10">
                    <div>
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Mieter/Fahrer
                        </h3>
                        <p class="mt-1 max-w-2xl text-gray-500">
                            Hier finden Sie alle Informationen zum
                            Mieter/Fahrer.
                        </p>
                    </div>
                    <div class="mt-5 border-t border-gray-200">
                        <dl class="sm:divide-y sm:divide-gray-200">
                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">Name</dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    <span v-if="booking.company"
                                        >{{ booking.company }}<br
                                    /></span>
                                    {{ booking.firstname }}
                                    {{ booking.lastname }}<br />
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Adresse
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.street }}<br />
                                    {{ booking.zip }} {{ booking.city }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Telefon
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.phone }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    E-Mail
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.email }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Geburtsort / Geburtsdatum
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.place_of_birth }} /
                                    {{ booking.date_of_birth }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Führerschein-Nummer
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.drivers_license_id }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Ausweis-Nummer
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.identity_card_id }}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>

                <div class="mt-10" v-if="booking.drivers[0].firstname">
                    <div>
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Weitere Fahrer
                        </h3>
                        <p class="mt-1 max-w-2xl text-gray-500">
                            Hier finden Sie alle Informationen zu den weiteren
                            Fahrern.
                        </p>
                    </div>
                    <div class="mt-5 border-t border-gray-200">
                        <dl class="sm:divide-y sm:divide-gray-200">
                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">Name</dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.drivers[0].firstname }}
                                    {{ booking.drivers[0].lastname }}<br />
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Adresse
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.drivers[0].street }}<br />
                                    {{ booking.drivers[0].zip }}
                                    {{ booking.drivers[0].city }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Geburtsort / Geburtsdatum
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.drivers[0].place_of_birth }} /
                                    {{ booking.drivers[0].date_of_birth }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Führerschein-Nummer
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.drivers[0].drivers_license_id }}
                                </dd>
                            </div>

                            <div
                                class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4"
                            >
                                <dt class="font-medium text-gray-500">
                                    Ausweis-Nummer
                                </dt>
                                <dd
                                    class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2"
                                >
                                    {{ booking.drivers[0].identity_card_id }}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </Container>
        </Section>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import StyledButton from "@/Components/StyledButton.vue";
import Container from "@/Components/Container.vue";
import Section from "@/Components/Section.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { PaperClipIcon } from "@heroicons/vue/solid";

export default {
    components: {
        AppLayout,
        StyledButton,
        Link,
        Container,
        Section,
        PaperClipIcon,
    },

    props: {
        booking: Object,
    },
};
</script>
